import styled from 'styled-components';

export const ModuleAccessWarningWrapper = styled.div`
  a:hover {
    color: ${({ theme }) => theme.text.blue};
  }
`;
